//////////////////////////////////////////////////////////////////////////////////////////////////
//  Foxbright Overlay object.
//   Manages an overlay on a page.
//   Assumes jQuery and geometry.js are present.
//////////////////////////////////////////////////////////////////////////////////////////////////

"use strict";

function FoxOverlay()
{
};


//////////////////////////////////////////////////////////////////////////////////////////////////
// Variables.
//////////////////////////////////////////////////////////////////////////////////////////////////

// overlay div id.
FoxOverlay.overlay_id = "fb_overlay";
// content div id.
FoxOverlay.overlay_content_id = "fb_overlay_content";
// content liner div
FoxOverlay.content_liner_class = "fb_overlay_content_liner";

// time (in milliseconds) that the overlay should fade.
FoxOverlay.fade_duration = 200;

//////////////////////////////////////////////////////////////////////////////////////////////////


//////////////////////////////////////////////////////////////////////////////////////////////////
// Places the overlay over the document and displays the dialog.
//  OPTIONAL PARAMETERS
//  fade_duration - the time, in milliseconds, that the overlay should be faded in/out.
//              this will override the default set when the FoxOverlay object was created.
//  callback - an (optional) function to call after the overlay is displayed.
FoxOverlay.showOverlay = function (fade_duration, callback) {
    var duration = FoxOverlay.fade_duration
    if (typeof (fade_duration) != "undefined") {
        duration = fade_duration;
    }

    // select elements are windowed controls and bleed through in IE, so hide temporarily
    //jQuery('admin_content').getElementsBySelector('select').invoke('toggle');

    // stretch overlay to fill page and fade in
    jQuery('#' + FoxOverlay.overlay_id).height(Geometry.getDocumentHeight() + "px");
    jQuery('#' + FoxOverlay.overlay_id).width(Geometry.getDocumentWidth() + "px");

    // position editor
    FoxOverlay.resizeContent();

    jQuery('#' + FoxOverlay.overlay_id).fadeIn(duration);
    jQuery('#' + FoxOverlay.overlay_content_id).fadeIn(duration, callback);
}; //end showOverlay


//////////////////////////////////////////////////////////////////////////////////////////////////
// Closes the content and removes the overlay from the screen.
//  OPTIONAL PARAMETERS
//  fade_duration - the time, in milliseconds, that the overlay should be faded in/out.
//              this will override the default set when the FoxOverlay object was created.
//  callback - an (optional) function to call after the overlay is closed.
FoxOverlay.closeOverlay = function (fade_duration, callback) {
    var duration = FoxOverlay.fade_duration
    if (typeof (fade_duration) != "undefined") {
        duration = fade_duration;
    }

    jQuery('#' + FoxOverlay.overlay_id).fadeOut(duration);
    jQuery('#' + FoxOverlay.overlay_content_id).fadeOut(duration, callback);

    jQuery('#' + FoxOverlay.overlay_content_id).find('.' + FoxOverlay.content_liner_class).empty();
    // select elements are windowed controls and bleed through in IE, so reshow
    //jQuery('admin_content').getElementsBySelector('select').invoke('toggle');
}; //end closeOverlay


//////////////////////////////////////////////////////////////////////////////////////////////////
// Resizes the content div (utility in case the content inside the div has changed).
FoxOverlay.resizeContent = function () {
    var lSizeMultiplier = 0.8;
    if (Geometry.getViewportWidth() < 479
        || Geometry.getViewportHeight() < 479) {
        lSizeMultiplier = 1.0;
    }

    jQuery('#' + FoxOverlay.overlay_content_id).height((Geometry.getViewportHeight() * lSizeMultiplier) + "px");
    jQuery('#' + FoxOverlay.overlay_content_id).width((Geometry.getViewportWidth() * lSizeMultiplier) + "px");

    // position editor
    var imageEditorTop = Math.floor(Geometry.getVerticalScroll() + (Geometry.getViewportHeight() / 2) - (jQuery('#' + FoxOverlay.overlay_content_id).height() / 2));
    var imageEditorLeft = Math.floor((Geometry.getViewportWidth() / 2) - (jQuery('#' + FoxOverlay.overlay_content_id).width() / 2));
    if (Geometry.getViewportWidth() < 479
        || Geometry.getViewportHeight() < 479) {
        imageEditorTop = Geometry.getVerticalScroll();
        imageEditorLeft = 0;
    }

    jQuery('#' + FoxOverlay.overlay_content_id).css('top', imageEditorTop + "px");
    jQuery('#' + FoxOverlay.overlay_content_id).css('left', imageEditorLeft + "px");
}; //end resizeContent


//////////////////////////////////////////////////////////////////////////////////////////////////
// Initializes the popup.
//  OPTIONAL PARAMETERS
//  fade_duration - the default time, in milliseconds, that the overlay should be faded in/out.
//              default - 200
//  overlay_id - id to be used for the overlay element, <overlay_id>_content is used for the content element.
//              default - fb_overlay
FoxOverlay.initOverlay = function (fade_duration, overlay_id) {
    if (typeof (fade_duration) != "undefined") {
        FoxOverlay.fade_duration = fade_duration;
    }
    if (typeof (overlay_id) != "undefined") {
        FoxOverlay.overlay_id = overlay_id;
        FoxOverlay.overlay_content_id = overlay_id + '_content';
    }

    if (jQuery('#' + FoxOverlay.overlay_id).length > 0) {
        // don't bother creating the divs if they already exist.
        return;
    }
}; //end initOverlay

FoxOverlay.appendContent = function (content) {
    jQuery('#' + FoxOverlay.overlay_content_id).find('.' + FoxOverlay.content_liner_class).append(content);
}; //end setContent